import { DeploymentStatus } from '@sonar-software/sonar-core';
import React from 'react';
import { Tag } from 'antd';

export interface DeploymentStatusTagProps {
	status: string | null | undefined;
}

export const DeploymentStatusTag: React.FC<DeploymentStatusTagProps> = ({ status }) => {
	if (!status) {
		return null;
	}

	const convertedStatus = DeploymentStatus[ status as keyof typeof DeploymentStatus ] as DeploymentStatus;

	let color;

	switch (convertedStatus) {
	case DeploymentStatus.Deployed:
		color = 'green';
		break;
	case DeploymentStatus.InDevelopment:
		color = 'gold';
		break;
	default:
		return null;
	}

	return <Tag color={ color }>{ convertedStatus }</Tag>;
};
